import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable()
export class OrganizationHeaderInterceptor implements HttpInterceptor {
  private readonly apiBaseUrl = environment.apiUrl || '';
  private readonly organizationName: string =
    environment.organizationName || 'default';

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.startsWith(this.apiBaseUrl)) {
      const cloned = req.clone({
        setHeaders: {
          'X-Organization-Name': this.organizationName,
        },
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
